var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9393",
    "data-name": "Group 9393",
    transform: "translate(-1687 -281)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3756",
    "data-name": "Rectangle 3756",
    width: 26,
    height: 26,
    transform: "translate(1687 281)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3755",
    "data-name": "Rectangle 3755",
    transform: "translate(1700 281.376) rotate(45)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.852,
    height: 17.852,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 15.852,
    height: 15.852,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_561",
    "data-name": "Line 561",
    y2: 10,
    transform: "translate(1700 288.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrint);
export default __webpack_public_path__ + "static/media/icon-print.bcf7ef32fd7140703e4b33b5582d44fd.svg";
export { ForwardRef as ReactComponent };